import type { ReactNode } from 'react';
import { cn } from '~/lib/cn.js';

/** Consistent vertical rhythm and the small uppercase eyebrow used throughout. */
export function Section({
  id,
  label,
  heading,
  children,
  className,
}: {
  id?: string;
  label?: string;
  heading?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section id={id} className={cn('scroll-mt-24 py-16 sm:py-20', className)}>
      <div className="mx-auto max-w-(--container-content) px-5 sm:px-8">
        {label ? <p className="section-label">{label}</p> : null}
        {heading ? <h2 className="mt-3 max-w-3xl display-2">{heading}</h2> : null}
        <div className={cn(label || heading ? 'mt-10' : undefined)}>{children}</div>
      </div>
    </section>
  );
}
